import { useMemo, useCallback } from "react";

import { useGetWalletsQuery } from "services/walletApi";

const useWalletBalance = () => {
  const { data: wallets, isLoading } = useGetWalletsQuery();

  const currencies = useMemo(() => {
    if (wallets) {
      return {
        cryptos: wallets?.addresses?.filter((a) => a?.address && a?.coin),
        fiats: wallets?.addresses?.filter((a) => !a?.address && a?.coin),
      };
    }
  }, [wallets]);

  const cryptos = useMemo(
    () =>
      currencies?.cryptos?.filter(
        (crypto) => !["usdt-matic", "usdc-matic"].includes(crypto?.coin)
      ),
    [currencies]
  );

  //   console.log("CURRENCIES", currencies);

  const getCoin = useCallback(
    (coin) => {
      if (wallets) {
        return wallets?.addresses?.find((a) => a?.coin === coin);
      }
    },
    [wallets]
  );

  const getBalance = useCallback(
    (coin) => getCoin(coin)?.balance?.$numberDecimal,
    [getCoin]
  );

  return {
    isLoading,
    cryptos: cryptos ?? [],
    fiats: currencies?.fiats ?? [],
    getCoin,
    getBalance,
  };
};

export default useWalletBalance;
